export default __webpack_public_path__ + "static/media/host-control-check.0bb098e9.svg";